import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container page-frame" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row justify-content-center my-3" }
const _hoisted_4 = { class: "col-4 mx-3 payment-stop-text" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_6 = {
  key: 1,
  class: "text-info"
}
const _hoisted_7 = { class: "row justify-content-center my-3" }
const _hoisted_8 = { class: "col-4 mx-3 payment-stop-text" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = {
  key: 1,
  class: "text-info"
}
const _hoisted_11 = { class: "row justify-content-center my-3" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.authStore.getters.authLevel !== _ctx.authLevels.DIST_STAFF)
      ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
          key: 0,
          here: '支払い停止・再開',
          ancestries: _ctx.ancestries
        }, null, 8, ["ancestries"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "col h2",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.large2})
      }, _toDisplayString(_ctx.staff.userName) + "さんの支払い停止・再開", 5)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[4] || (_cache[4] = _createTextVNode("月払い ", -1)),
        (_ctx.monthPaymentStopped)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "停止中"))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, "利用可能"))
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["col-4 btn mx-3", _ctx.monthPaymentStopped ? 'btn-info' : 'btn-danger']),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickSwitchMonthStop && _ctx.onClickSwitchMonthStop(...args)))
      }, _toDisplayString(_ctx.monthPaymentStopped ? '月払い再開' : '月払い停止'), 3)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[5] || (_cache[5] = _createTextVNode("前払い ", -1)),
        (_ctx.prepaymentStopped)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "停止中"))
          : (_openBlock(), _createElementBlock("span", _hoisted_10, "利用可能"))
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["col-4 btn mx-3", _ctx.prepaymentStopped ? 'btn-info' : 'btn-danger']),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickSwitchPrepaymentStop && _ctx.onClickSwitchPrepaymentStop(...args)))
      }, _toDisplayString(_ctx.prepaymentStopped ? '前払い再開' : '前払い停止'), 3)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "col-4 btn btn-info mx-3",
        disabled: !_ctx.monthPaymentStopped && !_ctx.prepaymentStopped,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickResumeBoth && _ctx.onClickResumeBoth(...args)))
      }, "両方再開", 8, _hoisted_12),
      _createElementVNode("button", {
        class: "col-4 btn btn-danger mx-3",
        disabled: _ctx.monthPaymentStopped && _ctx.prepaymentStopped,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickStopBoth && _ctx.onClickStopBoth(...args)))
      }, "両方停止", 8, _hoisted_13)
    ])
  ]))
}